export const ExamplesInLearn = {
  state: {
    limit: 5
  },
  tag: 'form',
  CaptionTitle: {
    width: '100%',
    align: 'center',
    Text: {
      text: '{{ learn.examples.title | polyglot }}'
    },
    ExpandButton: {
      extends: ['CanvasButton', 'IconButton'],
      margin: '- - - auto',
      icon: 'expand',
      aria: { label: (el) => el.call('polyglot', 'learn.examples.open') },
      onClick: (ev, el) => {
        el.setWindow('docs', '/examples')
      }
    }
  },
  Flex: {
    flow: 'y',
    gap: 'A',
    margin: '- - - -X',
    childExtends: 'ExampleItemInLearn',
    childrenAs: 'state',
    children: (el, s) =>
      [
        {
          poster: 'example_counter.png',
          descr: 'learn.example.counter.descr',
          title: 'learn.example.counter.title'
        },
        {
          poster: 'example_conditional.png',
          descr: 'learn.example.conditional.descr',
          title: 'learn.example.conditional.title'
        },
        {
          poster: 'example_toggling-state.png',
          descr: 'learn.example.toggling.descr',
          title: 'learn.example.toggling.title'
        },
        {
          poster: 'example_fetch.png',
          descr: 'learn.example.fetch.descr',
          title: 'learn.example.fetch.title'
        },
        {
          poster: 'example_form-input.png',
          descr: 'learn.example.formInput.descr',
          title: 'learn.example.formInput.title'
        },
        {
          poster: 'example_clock.png',
          descr: 'learn.example.clock.descr',
          title: 'learn.example.clock.title'
        },
        {
          poster: 'example_tabs.png',
          descr: 'learn.example.tabs.descr',
          title: 'learn.example.tabs.title'
        },
        {
          poster: 'example_accordion.png',
          descr: 'learn.example.accordion.descr',
          title: 'learn.example.accordion.title'
        },
        {
          poster: 'example_progress.png',
          descr: 'learn.example.progress.descr',
          title: 'learn.example.progress.title'
        },
        {
          poster: 'example_dynamic.png',
          descr: 'learn.example.dynamicList.descr',
          title: 'learn.example.dynamicList.title'
        }
      ].slice(0, s.limit || 30)
  },
  InsertSectionShadow: {
    left: '-C1',
    right: '-C1',
    bottom: 'C'
  },
  Flex_buttons: {
    childExtends: ['CanvasButton', 'Button'],
    margin: '- - - -Y2',
    zIndex: 2,
    Button: {
      icon: (el, s) => 'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
      text: (el, s) =>
        el.call('polyglot', s.limit === 5 ? 'learn.examples.more' : 'learn.examples.less'),
      gap: 'Y1',
      padding: 'Y2 Z2',
      color: 'caption',
      fontSize: 'Z2',
      Icon: {
        order: 2
      },
      onClick: (ev, el, s) => {
        s.update({
          limit: s.limit === 5 ? 30 : 5
        })
      }
    }
  },
  flow: 'y',
  align: 'start',
  gap: 'A',
  position: 'relative'
}
